import ScrollReveal from './ScrollReveal';
import { useTranslation } from 'react-i18next';

const Statement = () => {
  const { t } = useTranslation();
  const tags = t('statement.tags', { returnObjects: true });

  return (
    <section className='py-32 md:py-44 px-6 md:px-8 bg-neutral-50'>
      <div className='max-w-6xl mx-auto'>
        {/* label */}

        <ScrollReveal>
          <p className='text-red-500 uppercase tracking-widest text-xs md:text-sm mb-6'>
            {t('statement.label')}
          </p>
        </ScrollReveal>

        {/* title */}

        <ScrollReveal delay={0.1}>
          <h2
            className='
            font-semibold
            leading-tight
            mb-10

            text-[34px]
            sm:text-[42px]
            md:text-[56px]
            lg:text-[64px]
            '
          >
            {t('statement.title1')}
            <br />
            {t('statement.title2')}
            <span className='text-red-500'> {t('statement.title3')}</span>
          </h2>
        </ScrollReveal>

        {/* description */}

        <ScrollReveal delay={0.2}>
          <p
            className='
            text-neutral-600
            max-w-xl
            leading-relaxed
            mb-14

            text-base
            md:text-lg
            lg:text-xl
            '
          >
            {t('statement.desc')}
          </p>
        </ScrollReveal>

        {/* keywords */}

        <ScrollReveal delay={0.3}>
          <div className='flex flex-wrap gap-3 md:gap-4'>
            {tags.map((tag) => (
              <div
                key={tag}
                className='
                px-4 py-2
                rounded-full
                bg-white
                border border-neutral-200
                text-xs md:text-sm
                text-neutral-700
                shadow-sm
                hover:shadow-md
                transition
                '
              >
                {tag}
              </div>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default Statement;
